import styled from 'styled-components'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { styled as muiStyled } from '@mui/system'
import { Link } from 'react-router-dom'

export const PAHFinalParent = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  left: 0;
  right: 0;
  box-sizing: border-box;
`

export const PAHContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  align-items: center;
  background: #fff;
  font-family: Outfit;
  height: 64px;
  width: 100%;
  border-bottom: 1px solid rgba(148, 163, 184, 0.32);
  box-shadow: 0 12px 30px -24px rgba(15, 23, 42, 0.38);
  padding: 0 16px;
  box-sizing: border-box;
  left: 0;
  right: 0;
`

export const PAHHeightCompensation = styled.div`
  width: 100%;
  height: 64px;
  flex-shrink: 0;
`
export const PAHLOGOLink = styled(Link)`
  text-decoration: none;
  display: flex;
`

export const PAHLogo = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  &:hover {
    cursor: pointer;
  }
`

export const PAHItemsContainerRight = styled.div`
  display: flex;
  position: absolute;
  right: 16px;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 12px;
  box-sizing: border-box;
`

// links and buttons:

export const PAHActionButton = styled.button`
  background: #705dbb;
  font-weight: 500;
  text-decoration: none;
  color: #fff;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #514387;
    color: #fff;
  }
  font-size: 16px;
  padding: 8px 12px;
  border-radius: 10px;
`

export const PAHLoginButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  border: 1px solid rgba(112, 93, 187, 0.36);
  background: linear-gradient(180deg, #ffffff 0%, #f7f3ff 100%);
  font-weight: 700;
  text-decoration: none;
  color: #514387;
  transition: all 0.18s ease-in-out;
  font-size: 15px;
  line-height: 1;
  padding: 8px 14px;
  border-radius: 9999px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06),
    0 0 0 1px rgba(112, 93, 187, 0.06);
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background: #705dbb;
    border-color: #705dbb;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 8px 18px -12px rgba(81, 67, 135, 0.75);
  }
`

export const PAHSecondaryActionButton = styled.button`
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 6px;
  text-decoration: none;
  background: #e0e0e1;
  font-weight: 500;
  color: #000;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #adadae;
    color: #000;
  }
  @media (min-width: 991px) {
    font-size: 16px;
    padding: 8px 12px;
    border-radius: 10px;
  }
`

export const PAHLinkInHeader = styled(Link).withConfig({
  shouldForwardProp: (prop) => prop !== 'hideOnSmall',
})`
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 10px;
  color: #27325a;
  cursor: pointer;
  &:hover {
    color: #27325a;
    background: #f4f6fa;
  }
  ${(props) => props?.hideOnSmall && 'display: none;'};
  @media (min-width: 991px) {
    display: unset;
  }
`

export const PAHTextInHeader = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'hideOnSmall',
})`
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 10px;
  color: #27325a;
  cursor: pointer;
  &:hover {
    color: #27325a;
    background: #f4f6fa;
  }
  ${(props) => props?.hideOnSmall && 'display: none;'};
  @media (min-width: 991px) {
    display: unset;
  }
`

// overlays and menus:

export const PAHOverlayMenuContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  transition: ${(props) =>
    props?.fullHeight > 1000 ? 'all 0.5s ease-in-out' : 'all 0.4s ease-in-out'};
  height: ${(props) => (props?.fullHeightMenuOpen ? `${props?.fullHeightValue - 64}px` : '0')};
  background: #fafafa;
  overflow: hidden;
  z-index: 99;
`

export const PAHOverlayMenu = styled.div`
  padding: 30px 16px;
  height: calc(100vh - 64px);
  overflow: scroll;
  @media (min-width: 991px) {
    display: none;
  }
`

export const PAHCaretDownDefault = muiStyled(KeyboardArrowUpIcon, {
  shouldForwardProp: (prop) => prop !== 'isDown',
})(
  ({ theme, isDown }) => `
    transform: ${isDown ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: all 0.4s ease-in-out;
    font-size: 20px;
  `,
)

export const PAHMegaDropdownMenu = styled.div`
  background: #fafafa;
  margin-top: 64px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  display: none;
  @media (min-width: 991px) {
    display: ${(props) => (props?.open ? 'flex' : 'none')};
  }
`

export const PAHMegaDropdownContainer = styled.div`
  width: 100%;
  padding: 20px 30px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  justify-items: center;
`

export const PAHMegaDropdownText = styled.div`
  font-weight: ${(props) => (props?.main ? '500' : '400')};
  font-size: 12px;
  cursor: ${(props) => (props?.main ? 'default' : 'pointer')};
  text-decoration: none;
  color: #374253;
`

export const PAHMegaDropdownLink = styled(Link)`
  font-weight: ${(props) => (props?.main ? '500' : '400')};
  font-size: 12px;
  text-decoration: none;
  color: #374253;
  &:hover {
    text-decoration: underline;
  }
`
